<template>
  <!-- BMI 管理：与其他管理页统一使用 AnkhList + TableList 布局 -->
  <ankh-list>
    <template #btn-group>
      <el-button type="primary" @click.native="handleAdd">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input v-model="searchForm.name" clearable :placeholder="$t('名称')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button size="small" @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :request-params="{refRecommend: $route.query.code}"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="60" fixed />

        <el-table-column prop="name" :label="$t('名称')" />
        <el-table-column :label="$t('区间值')">
          <template v-slot="{row}">
            {{ row.rangeText }}
          </template>
        </el-table-column>
<!--        <el-table-column :label="$t('体重区间')">-->
<!--          <template v-slot="{row}">-->
<!--            {{ row.weightRangeText }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column :label="$t('颜色')" align="center">
          <template v-slot="{row}">
            <div v-if="row.color" class="color-display">
              <span
                class="color-block"
                :style="{ backgroundColor: row.color }"
                :title="row.color"
              ></span>
              <span class="color-text">{{ row.color }}</span>
            </div>
            <span v-else class="no-color">-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('排序')" prop="sort" />
        <el-table-column :label="$t('更新时间')">
          <template v-slot="{row}">
            {{ row.updateTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('操作')" width="160" fixed="right" align="center">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleEdit(row)">{{ $t('编辑') }}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>

      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="showDialog" :title="dialogTitle" :close-on-click-modal="false" width="520px" @close="resetDialog" class="bmi-dialog">
        <el-form :model="form" :rules="rules" ref="form" label-width="90px" class="compact-form">
          <el-form-item :label="$t('名称')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('名称')" />
          </el-form-item>
          <el-form-item :label="$t('区间值')" prop="rangeText">
            <range-input
              v-model="form.rangeText"
            />
          </el-form-item>
<!--          <el-form-item :label="$t('体重区间')" prop="weightRangeText">-->
<!--            <range-input-->
<!--              v-model="form.weightRangeText"-->
<!--            />-->
<!--          </el-form-item>-->
          <el-form-item :label="$t('颜色')" prop="color">
            <el-color-picker
              v-model="form.color"
              :predefine="predefineColors"
              color-format="hex"
              :show-alpha="false"
              :placeholder="$t('请选择颜色')"
            />
          </el-form-item>
          <el-form-item :label="$t('排序')" prop="sort">
            <el-input v-model="form.sort" :placeholder="$t('排序')" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">{{ $t('取消') }}</el-button>
          <el-button type="primary" @click="handleSubmit">{{ $t('确定') }}</el-button>
        </span>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import AnkhList from '@/components/list/AnkhList.vue'
import TableList from '@/components/table-list/TableList'
import RangeInput from '@/components/range-input/RangeInput.vue'
import { request, requestByTip } from '@/config/request'

export default {
  name: 'BmiManageList',
  components: { AnkhList, TableList, RangeInput },
  data() {
    return {
      searchForm: {
        name: '',
      },
      tableData: [],
      selection: [],
      showDialog: false,
      isEdit: false,
      form: {
        id: undefined,
        version: undefined,
        code: undefined,
        name: '',
        // 前端输入用，提交时解析为 min/max/symbol
        rangeText: '',
        // 体重区间字段
        weightRangeText: '',
        color: '',
        sort: 1,
      },
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#ff1493',
        '#ff6347',
        '#32cd32',
        '#00bfff',
        '#9370db'
      ],
      rules: {
        name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
        rangeText: [
          { required: true, message: this.$t('请输入区间值'), trigger: ['blur','change'] },
          { validator: this.validateRangeText, trigger: ['blur','change'] }
        ],
        weightRangeText: [
          { required: true, message: this.$t('请输入体重区间'), trigger: ['blur','change'] },
          { validator: this.validateWeightRangeText, trigger: ['blur','change'] }
        ],
      },
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      try {
        // 合并搜索与分页参数；request 封装会过滤空值
        const query = Object.assign({}, params)
        const resp = await request(this.$api.bmi.list, query)
        const list = (resp.bmis || []).map(it => {
          const rangeText = this.buildRangeText(it.symbol, it.min, it.max)
          const weightRangeText = this.buildRangeText(it.weightSymbol, it.weightMin, it.weightMax)
          return Object.assign({}, it, { rangeText, weightRangeText })
        })
        this.tableData = list
        setTotal && setTotal(resp.pager && resp.pager.itemCount)
      } catch (e) {
        console.error(e)
      }
    },
    handleAdd() {
      this.isEdit = false
      this.showDialog = true
      this.form = { id: undefined, version: undefined, code: undefined, name: '', rangeText: '', weightRangeText: '', color: '', sort: 1 }
    },
    handleEdit(row) {
      this.isEdit = true
      this.showDialog = true
      // 回填表单，rangeText 按后端字段统一渲染
      const rangeText = this.buildRangeText(row.symbol, row.min, row.max)
      const weightRangeText = this.buildRangeText(row.weightSymbol, row.weightMin, row.weightMax)
      this.form = Object.assign({}, row, { rangeText, weightRangeText })
    },
    async handleDelete(row) {
      try {
        if (!row || !row.code) {
          this.$message.error(this.$t('缺少主键code，无法删除'))
          return
        }
        await requestByTip(this.$api.bmi.delete, { code: row.code })
        this.$message.success(this.$t('删除成功'))
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {
        console.error(this.$t('删除失败:'), e)
      }
    },
    async handleBatchDelete() {
      if (!this.selection || !this.selection.length) {
        this.$message.warning(this.$t('请选择需要删除的记录'))
        return
      }
      try {
        const codes = this.selection.map(it => it.code).filter(Boolean)
        if (!codes.length) {
          this.$message.error(this.$t('所选记录缺少主键code'))
          return
        }
        await requestByTip(
          this.$api.bmi.batchDelete,
          codes,
          { isJson: true },
          { message: this.$t('您现在正在进行批量删除操作, 是否继续?') }
        )
        this.$message.success(this.$t('删除成功'))
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {
        console.error(this.$t('批量删除失败:'), e)
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        const { min, max, symbol } = this.parseRangeToPayload(this.form.rangeText)
        // const { min: weightMin, max: weightMax, symbol: weightSymbol } = this.parseRangeToPayload(this.form.weightRangeText)

        // 统一装配 payload，仅包含后端所需字段
        const payload = {
          name: this.form.name,
          min: min,
          max: max,
          symbol: symbol,
          color: this.formatColorToHex(this.form.color),
          id: this.form.id,
          version: this.form.version,
          code: this.form.code,
          refRecommend: this.$route.query.code,
          sort: this.form.sort
        }

        // 清理未定义字段，保持风格一致
        Object.keys(payload).forEach(k => (payload[k] === undefined || payload[k] === null) && delete payload[k])

        if (this.isEdit) {
          if (!payload.code) {
            this.$message.error(this.$t('缺少主键code，无法更新'))
            return
          }
          await request(this.$api.bmi.update, payload)
        } else {
          await request(this.$api.bmi.add, payload)
        }

        this.$message.success(this.$t('保存成功'))
        this.showDialog = false
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {}
    },
    /**
     * 将区间输入文本解析为后端需要的字段（min、max、symbol）
     * 支持：
     *  - 单值："< 18.5"、"≤ 20"、"= 21"、"≥ 28"、"> 30"
     *  - 区间："18.5 - 23.9"
     */
    parseRangeToPayload(text) {
      const result = { min: '', max: '', symbol: '' }
      if (!text) return result

      const trimmed = String(text).trim()
      // 区间：中间以 - 分隔
      if (trimmed.includes('-')) {
        const parts = trimmed.split('-')
        const left = (parts[0] || '').trim()
        const right = (parts[1] || '').trim()
        result.min = left
        result.max = right
        result.symbol = '-'
        return result
      }

      // 单值：操作符 + 数字
      const single = trimmed.match(/^([<≤=≥>])\s*([\d.]+)$/)
      if (single) {
        result.symbol = single[1]
        result.min = single[2]
        result.max = ''
        return result
      }

      // 兜底：无法解析时全部置空，交由后端/校验提示
      return result
    },
    resetDialog() {
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate && this.$refs.form.clearValidate()
        this.form = {};
      })
    },
    /**
     * 验证区间值格式
     * @param {Object} rule - 验证规则
     * @param {string} value - 要验证的值
     * @param {Function} callback - 回调函数
     */
    validateRangeText(rule, value, callback) {
      if (!value) {
        // 交由 required 规则在提交/失焦时提示，这里不重复报错
        callback()
        return
      }

      // 若用户尚未输入任何数字（仅选择了操作符或处于输入中），不提示为错误，避免误导
      if (!/[0-9]/.test(value)) {
        callback()
        return
      }

      // 单值格式验证：如 "< 18.5" 或 "≥ 25"
      const singlePattern = /^[<≤=≥>]\s*[\d.]+$/
      // 区间格式验证：如 "18.5 - 23.9" 或 "≤ 18.5 - < 23.9"
      const rangePattern = /^([<≤]?\s*[\d.]+)\s*-\s*([<≤]?\s*[\d.]+)$/

      if (singlePattern.test(value)) {
        // 验证单值
        const match = value.match(/^([<≤=≥>])\s*([\d.]+)$/)
        if (match) {
          const num = parseFloat(match[2])
          if (isNaN(num) || num < 0 || num > 50) {
            callback(new Error(this.$t('数值必须在0-50之间')))
            return
          }
        }
      } else if (rangePattern.test(value)) {
        // 验证区间
        const match = value.match(/^([<≤]?\s*[\d.]+)\s*-\s*([<≤]?\s*[\d.]+)$/)
        if (match) {
          const leftNum = parseFloat(match[1].replace(/[<≤]/g, '').trim())
          const rightNum = parseFloat(match[2].replace(/[<≤]/g, '').trim())

          if (isNaN(leftNum) || isNaN(rightNum)) {
            callback(new Error(this.$t('区间值格式不正确')))
            return
          }

          if (leftNum < 0 || leftNum > 50 || rightNum < 0 || rightNum > 50) {
            callback(new Error(this.$t('数值必须在0-50之间')))
            return
          }

          if (leftNum >= rightNum) {
            callback(new Error(this.$t('左值必须小于右值')))
            return
          }
        }
      } else {
        callback(new Error(this.$t('区间值格式不正确，支持单值如"< 18.5"或区间如"18.5 - 23.9"')))
        return
      }

      callback()
    },
    /**
     * 验证体重区间值格式
     * @param {Object} rule - 验证规则
     * @param {string} value - 要验证的值
     * @param {Function} callback - 回调函数
     */
    validateWeightRangeText(rule, value, callback) {
      if (!value) {
        // 交由 required 规则在提交/失焦时提示，这里不重复报错
        callback()
        return
      }

      // 若用户尚未输入任何数字（仅选择了操作符或处于输入中），不提示为错误，避免误导
      if (!/[0-9]/.test(value)) {
        callback()
        return
      }

      // 单值格式验证：如 "< 18.5" 或 "≥ 25"
      const singlePattern = /^[<≤=≥>]\s*[\d.]+$/
      // 区间格式验证：如 "18.5 - 23.9" 或 "≤ 18.5 - < 23.9"
      const rangePattern = /^([<≤]?\s*[\d.]+)\s*-\s*([<≤]?\s*[\d.]+)$/

      if (singlePattern.test(value)) {
        // 验证单值
        const match = value.match(/^([<≤=≥>])\s*([\d.]+)$/)
        if (match) {
          const num = parseFloat(match[2])
          if (isNaN(num) || num < 0 || num > 200) {
            callback(new Error(this.$t('体重数值必须在0-200之间')))
            return
          }
        }
      } else if (rangePattern.test(value)) {
        // 验证区间
        const match = value.match(/^([<≤]?\s*[\d.]+)\s*-\s*([<≤]?\s*[\d.]+)$/)
        if (match) {
          const leftNum = parseFloat(match[1].replace(/[<≤]/g, '').trim())
          const rightNum = parseFloat(match[2].replace(/[<≤]/g, '').trim())

          if (isNaN(leftNum) || isNaN(rightNum)) {
            callback(new Error(this.$t('体重区间值格式不正确')))
            return
          }

          if (leftNum < 0 || leftNum > 200 || rightNum < 0 || rightNum > 200) {
            callback(new Error(this.$t('体重数值必须在0-200之间')))
            return
          }

          if (leftNum >= rightNum) {
            callback(new Error(this.$t('左值必须小于右值')))
            return
          }
        }
      } else {
        callback(new Error(this.$t('体重区间值格式不正确，支持单值如"< 50"或区间如"50 - 80"')))
        return
      }

      callback()
    },
    /**
     * 依据后端字段生成统一区间展示文本
     * @param {string} symbol - 操作符：'-'、'<','≤','=','≥','>'
     * @param {string} min - 最小值（单值时为该值）
     * @param {string} max - 最大值（仅区间时使用）
     */
    buildRangeText(symbol, min, max) {
      const s = symbol || ''
      const l = (min || '').toString().trim()
      const r = (max || '').toString().trim()
      if (s === '-') {
        if (l && r) return `${l} - ${r}`
        // 容错：缺一端时退化为单值显示
        if (l) return l
        if (r) return r
        return ''
      }
      // 单值：操作符 + 空格 + 值
      return l ? `${s} ${l}` : ''
    },
    /**
     * 将颜色值格式化为16进制字符串
     * @param {string} color - 颜色值
     * @returns {string} 16进制格式的颜色字符串
     */
    formatColorToHex(color) {
      if (!color) return ''

      // 如果已经是16进制格式，直接返回
      if (/^#[0-9A-Fa-f]{6}$/.test(color)) {
        return color.toUpperCase()
      }

      // 如果是rgb格式，转换为16进制
      if (color.startsWith('rgb')) {
        const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
        if (rgbMatch) {
          const r = parseInt(rgbMatch[1])
          const g = parseInt(rgbMatch[2])
          const b = parseInt(rgbMatch[3])
          return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase()
        }
      }

      // 如果是rgba格式，转换为16进制（忽略透明度）
      if (color.startsWith('rgba')) {
        const rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*[\d.]+\)/)
        if (rgbaMatch) {
          const r = parseInt(rgbaMatch[1])
          const g = parseInt(rgbaMatch[2])
          const b = parseInt(rgbaMatch[3])
          return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase()
        }
      }

      // 如果格式不正确，返回空字符串
      return ''
    },
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('编辑') : this.$t('新增')
    }
  }
}
</script>

<style scoped>
/* 对话框样式优化 */
.bmi-dialog .el-dialog__body {
  padding: 20px 20px 10px;
}

.compact-form .el-form-item {
  margin-bottom: 18px;
}

.compact-form .el-form-item__label {
  font-weight: 500;
  color: #303133;
}

/* 颜色显示样式 */
.color-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.color-block {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  display: inline-block;
  cursor: pointer;
}

.color-text {
  font-size: 12px;
  color: #606266;
  font-family: monospace;
}

.no-color {
  color: #c0c4cc;
  font-style: italic;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .bmi-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}
</style>



